export interface DocumentInfo {
  fileId: number;
  type: string;
  name: string;
  path: string;
  size: number;
  contentType: string;
  uri: string;
}
